var exports = {
  "vR": "RiverAccordion__IL2JhL",
  "fh": "Cell__T4UHEj",
  "UC": "Content__0xAY6R",
  "As": "AccordionItem__HqU_1H",
  "Xo": "AccordionSummary__cB1DCc",
  "QJ": "AccordionIcon__wsFp7I",
  "YJ": "AccordionContainer__X-XjRX",
  "ub": "AccordionContent__X9W4uJ",
  "VY": "Description__0F3N4M",
  "_V": "Image__rnbgyr",
};

module.exports = exports;
